<template>
  <v-overlay
    :absolute="true"
    :value="overlay"
    opacity="1"
    color="error"
    class="align-start"
  >
    <v-row no-gutters>
      <img
        v-if="['rs', 'rs-lat', 'en'].includes($i18n.locale)"
        :src="`./media/img/sledeci-${$i18n.locale}.jpg`"
        height="auto"
        width="100%"
      />
      <img v-else :src="`./media/img/sledeci-rs-lat.jpg`" height="auto" width="100%" />
    </v-row>
    <p
      v-if="!nextManual"
      class="display-2 font-weight-bold full-width text-center py-4"
      :style="{ fontSize: subFontSize, padding: subPadding }"
    >
      {{ seconds }}s
    </p>
    <slot></slot>
  </v-overlay>
</template>

<script>
import conf from "@/config";

export default {
  props: {
    overlay: {
      type: Boolean,
    },
    client: {
      type: Object,
    },
    nextManual: {
      type: Boolean,
    },
    seconds: {
      type: Number,
    },
  },
  data() {
    return {
      conf: conf,
    };
  },
  computed: {
    mainFontSize() {
      if (this.device?.isMobile) return "20px";
      if (this.device?.isTablet) return "28px";
      return "34px";
    },
    subFontSize() {
      if (this.device?.isMobile) return "14px";
      if (this.device?.isTablet) return "18px";
      return "22px";
    },
    mainPadding() {
      if (this.device?.isMobile) return "8px";
      if (this.device?.isTablet) return "16px";
      return "24px";
    },
    subPadding() {
      if (this.device?.isMobile) return "4px";
      if (this.device?.isTablet) return "8px";
      return "12px";
    },
  },
  methods: {
    getInitials(user) {
      const firstInitial = user?.name?.trim()?.charAt(0).toUpperCase() || "";
      const lastInitial = user?.lastname?.trim()?.charAt(0).toUpperCase() || "";
      return this.toLatin(firstInitial + lastInitial);
    },
  },
};
</script>
